export default "__VITE_ASSET__DBFiZ$wB__"